// client/src/services/authService.js
// This file acts as a generic interface for authentication services.
// It currently re-exports functions from supabaseAuthService.js.
// To switch authentication providers, modify this file to import from a different service.

import supabaseAuthService from './supabase/supabaseAuthService';

const authService = {
  getSession: supabaseAuthService.getSession,
  onAuthStateChange: supabaseAuthService.onAuthStateChange,
  signUp: supabaseAuthService.signUp,
  signInWithPassword: supabaseAuthService.signInWithPassword,
  signOut: supabaseAuthService.signOut,
  resetPasswordForEmail: supabaseAuthService.resetPasswordForEmail,
  updateUser: supabaseAuthService.updateUser,
};

export default authService;
